<template>
  <base-card>
    <BaseCardTitle>
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <font-awesome-icon
            class="mr-2"
            :icon="['far','user']"
          /> Clients
        </div>
        <small>
          <font-awesome-icon
            icon="plus"
            class="cursor-pointer"
            @click="$refs.AssignStylist.open()"
          />
        </small>
      </div>
    </BaseCardTitle>
    <span v-if="this.stylist == null">
      NULL
    </span>
    <span v-else-if="this.stylist.team == null">
      {{ this.stylist.user.first_name }} is not assigned to a team. Contact your manager if you think this is an error.
    </span>
    <div
      v-for="(customer, index) in customers"
      :key="index"
    >
      <div class="d-flex align-items-center">
        <Avatar
          :size="44"
          class="mr-2"
          :img="customer.profile_pic"
          :username="`${customer.first_name} ${customer.last_name}`"
        />
        {{ customer.first_name }} {{ customer.last_name }}
      </div>
      <hr>
    </div>

    <!-- <ButtonMore /> -->
    <AssignStylist
      ref="AssignStylist"
      :stylist="stylist"
    />
  </base-card>
</template>

<script>
import AssignStylist from './AssignStylist';

export default {
  name: 'StylistCustomers',
  components: { AssignStylist },
  props: {
    stylist: Object,
  },
  computed: {
    customers() {
      return this.$store.state.customers.items;
    },
  },
  watch: {
    stylist(newVal, oldVal) {
      this.loadCustomers();
    },
  },
  mounted() {
    this.loadCustomers();
  },
  methods: {
    loadCustomers() {
      if (this.stylist && this.stylist.team) {
        this.$store.dispatch('customers/fetchForTeam', this.stylist.team.pk);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
